// src/authConfig.ts
export const msalConfig = {
  auth: {
    clientId:
      process.env.REACT_APP_CLIENT_ID ?? '075f65af-afa6-43e0-b29b-aab877d28709',
    authority: `https://login.microsoftonline.com/${
      process.env.REACT_APP_TENANT_ID ?? '6808f032-9a97-45ad-a386-f15dbeec56f2'
    }`,
    redirectUri: process.env.REACT_APP_URI ?? 'https://bookingb2b.sunworld.vn',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};
